import { useEffect, useState } from "react";
import axios from "axios";
import { FaHourglassHalf, FaClipboardCheck, FaUserCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";
import { InboxMetricCard } from "../../../inbox/components/molecules/InboxMetricCard";

export const MetricsOverview = () => {
  const [metrics, setMetrics] = useState({
    myRequests: 0,
    completedHires: 0,
    discarded: 0,
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const config = { headers: { Authorization: `Bearer ${token}` } };

    const fetchData = async () => {
      // My Requests
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/count`, config);
        setMetrics((prev) => ({ ...prev, myRequests: Number(res.data?.totalRequests) || 0 }));
      } catch (err) {
        console.error("Error fetching my requests:", err.response?.status, err.message);
      }

      // Completed Hires
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/completed-hires/count`, config);
        setMetrics((prev) => ({
          ...prev,
          completedHires: Number(res.data?.completedCount ?? res.data?.candidateCount) || 0,
        }));
      } catch (err) {
        console.error("Completed hires error:", err.response?.status, err.message);
      }

      // Discarded
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/discarded-hires/count`, config);
        setMetrics((prev) => ({ ...prev, discarded: Number(res.data?.discardedCount) || 0 }));
      } catch (err) {
        console.error("Discarded hires error:", err.response?.status, err.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="flex justify-start w-full">
      <div className="grid grid-cols-3 gap-x-6">
        <Link to="/tables">
          <InboxMetricCard
            title="My Requests"
            value={metrics.myRequests}
            Icon={FaUserCheck}
          />
        </Link>

        <InboxMetricCard
          title="Completed Hires"
          value={metrics.completedHires}
          Icon={FaHourglassHalf}
        />

        <InboxMetricCard
          title="Discarded"
          value={metrics.discarded}
          Icon={FaClipboardCheck}
        />
      </div>
    </div>
  );
};
